import { t } from "../i18n.ts";
import { Sheet } from "./Sheet.tsx";

const SECTIONS = [
  ["➕", "help.add.t", "help.add.d"],
  ["✨", "help.phrase.t", "help.phrase.d"],
  ["📊", "help.report.t", "help.report.d"],
  ["🧾", "help.receipt.t", "help.receipt.d"],
  ["🛒", "help.lists.t", "help.lists.d"],
  ["🐷", "help.goals.t", "help.goals.d"],
  ["🧊", "help.cook.t", "help.cook.d"],
  ["💊", "help.home.t", "help.home.d"],
  ["🔄", "help.sync.t", "help.sync.d"],
] as const;

const CHILD_SECTIONS = [
  ["🐷", "help.goals.t", "help.child.goals.d"],
  ["🛒", "help.lists.t", "help.lists.d"],
  ["🔄", "help.sync.t", "help.child.sync.d"],
] as const;

export function HelpSheet({ onClose, child = false }: { onClose: () => void; child?: boolean }) {
  const sections = child ? CHILD_SECTIONS : SECTIONS;
  return (
    <Sheet title={`❓ ${t("help")}`} onClose={onClose}>
      <ul className="row-list help-list">
        {sections.map(([icon, title, text]) => (
          <li key={title} className="row">
            <span className="row-icon" aria-hidden="true">
              {icon}
            </span>
            <div className="row-body">
              <div className="row-title">{t(title)}</div>
              <div className="row-text">{t(text)}</div>
            </div>
          </li>
        ))}
      </ul>
    </Sheet>
  );
}
